import React from "react";
import ReactDOM from "react-dom/client";
import { getCurrentLeadStatus } from "./amo/statuses";
import leadWindow from "./pages/LeadCard";
import SettingsWindow from "./pages/SettingsWindow";
import { ChakraProvider } from "@chakra-ui/react";
import { defaultSystem } from "@chakra-ui/react";
import { getProjectSettings } from "./api/project";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { clearChecklistBlocking } from "./services/pipelineService";
import "./widget-styles.css";

if (typeof window !== "undefined") {
    window.addEventListener("error", (event) => {
        event.preventDefault();
    });
    window.addEventListener("unhandledrejection", (event) => {
        event.preventDefault();
    });
}

const renderSettings = async () => {
    try {
        let widgetCode = sessionStorage.getItem("widget_code");

        if (!widgetCode) {
            const settings = await getProjectSettings();
            widgetCode = settings.widget_code;
            if (widgetCode) {
                sessionStorage.setItem("widget_code", widgetCode);
            }
        }

        if (!widgetCode) {
            console.error("Widget code is not available. Cannot render settings.");
            return;
        }

        const selector = `[id="work-area-${widgetCode}"]`;
        const intervalId = setInterval(() => {
            const container = document.querySelector(selector);
            if (container) {
                const div = document.createElement('div');
                const parent = container.parentElement;
                parent.replaceChild(div, container);

                ReactDOM.createRoot(div).render(
                    <>
                        <ChakraProvider value={defaultSystem}>
                            <DndProvider backend={HTML5Backend}>
                                <SettingsWindow />
                            </DndProvider>
                        </ChakraProvider>
                    </>
                );
                clearInterval(intervalId);
            }
        }, 500);
    } catch (error) {
        console.error("Failed to render widget settings:", error);
    }
};


const Widget = {
    render(self) {
        if (AMOCRM.data.current_entity === "leads") {
            // Очищаем состояние блокировки при входе в карточку сделки
            clearChecklistBlocking();
            
            let previousStatusId = getCurrentLeadStatus();
            let removeLastDom = () => {};
            leadWindow(previousStatusId)
                .then((rm) => {
                    removeLastDom = typeof rm === "function" ? rm : () => {};
                    const interval = setInterval(() => {
                        if (AMOCRM.data.current_entity !== "leads") {
                            // Очищаем состояние при выходе из карточки сделки
                            clearChecklistBlocking();
                            removeLastDom();
                            removeLastDom = () => {};
                            clearInterval(interval);
                            return;
                        }
                        const currentStatusId = getCurrentLeadStatus();
                        if (currentStatusId !== previousStatusId) {
                            // Очищаем состояние при изменении статуса/сделки
                            clearChecklistBlocking();
                            previousStatusId = currentStatusId;
                            removeLastDom();
                            leadWindow(currentStatusId)
                                .then((r) => { removeLastDom = typeof r === "function" ? r : () => {}; })
                                .catch(() => { removeLastDom = () => {}; });
                        }
                    }, 1000);
                })
                .catch(() => { removeLastDom = () => {}; });

        } else {
            renderSettings();
        }
        return true;
    },

    init() {
        return true;
    },

    bind_actions() {
        return true;
    },

    settings() {
        return true;
    },

    onSave() {
        return true;
    },

    destroy() {
        return true;
    },

    advancedSettings(self) {
        this.render(self);
        return true;
    }
};

export default Widget;
